var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import equal from 'fast-deep-equal';
import { RadioGroup as MuiRadioGroup, Radio, FormControl, FormLabel, FormControlLabel, FormHelperText, } from '@mui/material';
import { fieldValueIsSame, localeIsSame, } from '../../utils/formik';
var RadioGroup = function (_a) {
    var items = _a.items, _b = _a.error, error = _b === void 0 ? false : _b, label = _a.label, helperText = _a.helperText, radioGroupProps = __rest(_a, ["items", "error", "label", "helperText"]);
    return (React.createElement(FormControl, { component: "fieldset", error: error },
        label && React.createElement(FormLabel, { component: "legend" }, label),
        React.createElement(MuiRadioGroup, __assign({}, radioGroupProps), items.map(function (_a) {
            var text = _a.text, value = _a.value;
            return (React.createElement(FormControlLabel, { key: value, value: value, control: React.createElement(Radio, null), label: text }));
        })),
        helperText && React.createElement(FormHelperText, null, helperText)));
};
export default RadioGroup;
var FormikRadioGroupUnmemoized = function (_a) {
    var _b = _a.formik, errors = _b.errors, handleBlur = _b.handleBlur, formikHandleChange = _b.handleChange, values = _b.values, items = _a.items, radioGroupProps = __rest(_a, ["formik", "items"]);
    var nameAsKey = radioGroupProps.name;
    var onChange = radioGroupProps.onChange;
    var handleChange = React.useCallback(function (event, value) {
        formikHandleChange(event);
        onChange && onChange(event, value);
    }, [onChange, formikHandleChange]);
    return (React.createElement(RadioGroup, __assign({ items: items, onBlur: handleBlur, onChange: handleChange, value: values[nameAsKey], error: Boolean(errors[nameAsKey]), helperText: errors[nameAsKey] }, radioGroupProps)));
};
var itemsAreSame = function (prevProps, nextProps) { return equal(prevProps.items, nextProps.items); };
export var FormikRadioGroup = React.memo(FormikRadioGroupUnmemoized, function (prevProps, nextProps) {
    return localeIsSame(prevProps, nextProps) &&
        fieldValueIsSame(prevProps, nextProps) &&
        itemsAreSame(prevProps, nextProps);
});
